import { Auth } from "aws-amplify";
import { useContext, useEffect, useState } from "react";
import {
  GetUserQuery,
  UserType,
  useGetUserQuery,
  useGetUser_RootAdminChamberAdminQuery,
} from "../../../graphql/types";
import { UserTypeContext } from "../../../UserTypeContext";

const useGetChamberFromUserIdInAuth = ():
  | GetUserQuery["getUser"]["chamberInfo"]
  | undefined => {
  const [cognitoSub, setCognitoSub] = useState(undefined);
  useEffect(() => {
    const main = async (): Promise<void> => {
      const user = await Auth.currentAuthenticatedUser();
      setCognitoSub(user.attributes.sub);
    };
    main();
  }, []);

  const {
    state: { userType },
  } = useContext(UserTypeContext);

  const { data } = useGetUserQuery({
    variables: { userId: cognitoSub || "" },
    skip:
      !cognitoSub ||
      userType === "" || // need to check for empty string here because its set to empty string at logout... and this query shouldn't run while its empty string
      userType === UserType.PerkPartnerDiscountAdmin ||
      userType === UserType.RootAdmin ||
      userType === UserType.ChamberAdmin,
  });

  const { data: adminChamberEngageData } =
    useGetUser_RootAdminChamberAdminQuery({
      variables: { userId: cognitoSub || "" },
      skip:
        !cognitoSub ||
        userType === "" || // need to check for empty string here because its set to empty string at logout... and this query shouldn't run while its empty string
        userType === UserType.PerkPartnerDiscountAdmin ||
        userType === UserType.ChamberMemberAdmin,
    });

  // forcing return undefined here because perk partner discount admin users do not have a chamber
  if (userType === UserType.PerkPartnerDiscountAdmin) {
    return undefined;
  }

  return (
    data?.getUser?.chamberInfo || adminChamberEngageData?.getUser?.chamberInfo
  );
};

export default useGetChamberFromUserIdInAuth;
